(function () {
  // Landing de producto (LN-new)
  //
  // 07/09/2026 — Cambios:
  //  (a) El tope era de 1: alcanzaba con tener el producto en el carrito para
  //      que el botón quedara deshabilitado. Ahora cuenta la cantidad real.
  //  (b) Después de agregar no se abría nada: el JS buscaba <cart-drawer> y
  //      #cart-icon-bubble, que son de Dawn y no existen en este theme. El
  //      carrito de QN es window.QNCartDrawer.
  //  (c) Bloque "cuánto te falta": una sola barra que primero apunta al mínimo
  //      de compra y después al envío gratis, con productos sugeridos debajo.
  //  (d) Los productos que cuentan para el tope salen del bloque
  //      #qnHuevosUpsell (data-product-promo + data-product-also), igual que en
  //      el carrito. Antes esta página contaba solo su propio producto, así que
  //      con maples del otro producto en el carrito dejaba agregar de más y
  //      después el carrito los recortaba solo, sin avisar.
  //      OJO: el número del tope está en DOS lugares y tienen que coincidir:
  //      el ajuste "Máximo de unidades por compra" de esta sección (manda acá) y
  //      data-max-maples en snippets/QN-NEW-huevos-upsell.liquid (manda en el
  //      carrito y en el ticket).

  function init() {
    var root = document.getElementById('ln2-root');
    if (!root) return;

    var currency  = root.getAttribute('data-currency') || 'USD';
    var lang      = root.getAttribute('data-lang') || 'es-UY';
    var productId = root.getAttribute('data-product-id');

    // --- Qué cuenta para el tope, y cuál es el tope --------------------------
    // El bloque del ticket de huevos vive dentro del carrito, así que está en
    // todas las páginas. Si no estuviera, se usa lo de esta sección.
    var upsellEl = document.querySelector('#qnHuevosUpsell');
    var upsellData = upsellEl ? upsellEl.dataset : {};

    var countedIds = [];
    if (productId) countedIds.push(String(productId));
    [upsellData.productPromo, upsellData.productAlso].forEach(function (raw) {
      String(raw || '').split(',').forEach(function (id) {
        id = id.trim();
        if (id && countedIds.indexOf(id) === -1) countedIds.push(id);
      });
    });

    // Manda el ajuste de la sección; el del ticket queda de respaldo.
    var maxQty = parseInt(root.getAttribute('data-max-qty') || '0', 10)
      || parseInt(upsellData.maxMaples, 10)
      || 0; // 0 = sin tope

    var addLabel     = root.getAttribute('data-label-add')   || 'AGREGAR AL CARRITO';
    var addMoreLabel = root.getAttribute('data-label-more')  || 'AGREGAR OTRO';
    var limitLabel   = root.getAttribute('data-label-limit') || 'YA LLEVÁS EL MÁXIMO';

    var state = { basePrice: 0, variantId: null, qty: 0 };

    function moneyFromCents(cents) {
      cents = parseInt(cents || '0', 10) || 0;
      try {
        return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    var variantInput = document.getElementById('ln2VariantId');
    var btn          = document.getElementById('ln2CtaBtn');
    var form         = document.getElementById('ln2Form');
    var limitNote    = document.getElementById('ln2LimitNote');
    var vTiles       = root.querySelectorAll('#ln2VariantTiles .ln2-tile');

    // Bloque "cuánto te falta": mínimo de compra y envío gratis.
    var minBox    = document.getElementById('ln2Minimo');
    var minMsg    = minBox && minBox.querySelector('[data-minimo-msg]');
    var minFill   = minBox && minBox.querySelector('[data-minimo-fill]');
    var minSug    = minBox && minBox.querySelector('[data-minimo-sug]');
    var minAmount = minBox ? parseInt(minBox.getAttribute('data-minimo') || '0', 10) : 0;
    var envAmount = minBox ? parseInt(minBox.getAttribute('data-envio') || '0', 10) : 0;

    function pesos(n) {
      return '$' + Math.round(n).toLocaleString('es-UY');
    }

    // Un solo bloque para las dos metas: primero el mínimo, después el envío gratis.
    function updateMinimo(totalCents) {
      if (!minBox) return;

      var total = (totalCents || 0) / 100;
      var pct, msg, showSug = true;

      if (minAmount > 0 && total < minAmount) {
        pct = total / minAmount * 100;
        msg = 'Pedido mínimo de <strong>' + pesos(minAmount) + '</strong>. Te faltan <strong>'
            + pesos(minAmount - total) + '</strong>.';
      } else if (envAmount > 0 && total < envAmount) {
        pct = total / envAmount * 100;
        msg = 'Te faltan <strong>' + pesos(envAmount - total) + '</strong> para <strong>envío gratis</strong> en Montevideo.';
      } else {
        pct = 100;
        msg = 'Ya tenés <strong>envío gratis</strong> en Montevideo.';
        showSug = false;
      }

      if (minMsg) minMsg.innerHTML = msg;
      if (minFill) minFill.style.width = Math.max(0, Math.min(100, pct)) + '%';
      if (minSug) minSug.hidden = !showSug;
    }

    // ── Abrir el carrito real de QN ──────────────────
    function openCart() {
      if (typeof window.qnOpenCart === 'function') { window.qnOpenCart('/'); return; }
      var D = window.QNCartDrawer;
      if (!D || typeof D.open !== 'function') { window.location.href = '/cart'; return; }
      var refresh = null;
      try { if (typeof D.fetchCart === 'function') refresh = D.fetchCart(); } catch (e) { refresh = null; }
      Promise.resolve(refresh).catch(function () {}).then(function () {
        try { D.open(); } catch (e) { window.location.href = '/cart'; }
      });
    }

    // ── Cuántos maples lleva ya, sumando los productos que cuentan ──────────
    function checkCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          state.qty = (cart.items || []).reduce(function (n, item) {
            var pid = item.product_id != null ? String(item.product_id) : '';
            return countedIds.indexOf(pid) !== -1 ? n + item.quantity : n;
          }, 0);
          updateCTA();
          updateMinimo(cart.total_price);
        })
        .catch(function () {});
    }

    // ── CTA ────────────────────────────────────
    function updateCTA() {
      if (!btn) return;

      var atLimit = maxQty > 0 && state.qty >= maxQty;

      if (atLimit) {
        btn.disabled = true;
        btn.classList.add('ln2-disabled');
        btn.innerHTML = limitLabel;
      } else {
        btn.disabled = false;
        btn.classList.remove('ln2-disabled');
        btn.innerHTML = (state.qty > 0 ? addMoreLabel : addLabel) + ' — ' + moneyFromCents(state.basePrice);
      }

      // La nota del tope explica el porqué y ofrece la salida (el local).
      if (limitNote) limitNote.hidden = !atLimit;
    }

    // ── Init variante ────────────────────────────
    var firstTile = root.querySelector('.ln2-tile.is-active') || vTiles[0];

    if (firstTile) {
      state.basePrice = parseInt(firstTile.getAttribute('data-price') || '0', 10);
      state.variantId = firstTile.getAttribute('data-variant-id');
      if (variantInput) variantInput.value = state.variantId;
    }

    function setActiveVariant(tile) {
      vTiles.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-checked', 'false');
      });

      tile.classList.add('is-active');
      tile.setAttribute('aria-checked', 'true');

      state.basePrice = parseInt(tile.getAttribute('data-price') || '0', 10);
      state.variantId = tile.getAttribute('data-variant-id');

      if (variantInput) variantInput.value = state.variantId;

      updateCTA();
    }

    vTiles.forEach(function (tile) {
      tile.addEventListener('click', function () { setActiveVariant(tile); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveVariant(tile); }
      });
    });

    // ── Galería ───────────────────────────────
    var thumbs = root.querySelectorAll('.ln2-thumb');
    var mainImg = document.getElementById('ln2MainImg');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var large = thumb.getAttribute('data-large');
        if (mainImg && large) mainImg.src = large;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // ── Submit ────────────────────────────────
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        if (btn && btn.disabled) return;

        e.preventDefault();

        btn.disabled = true;
        btn.innerHTML = 'AGREGANDO…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            state.qty = state.qty + 1;
            updateCTA();
            document.dispatchEvent(new CustomEvent('cart:updated'));
            window.dispatchEvent(new CustomEvent('cart:updated'));
            openCart();
          })
          .catch(function (err) {
            console.error('Cart error:', err);
            btn.disabled = false;
            updateCTA();
          });
      });
    }

    document.addEventListener('cart:updated', checkCart);
    window.addEventListener('cart:updated', checkCart);

    checkCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
